import { SamsungPayButtonTypeEnumsObj } from "./enums/SamsungPayButtonTypeEnum";
import { SamsungPayButtonColorEnumsObj } from "./enums/SamsungPayButtonColorEnum";
import { SamsungPaySdkImpl } from "./core/SamsungPaySdk";
import { SamsungPayEventListenerEnumsObj } from "./enums/SamsungPayEventListenerEnum";
import { SamsungPayEventTypeEnumsObj } from "./enums/SamsungPayEventTypeEnum";
import { addGetVersionToWindow } from "@payair/e-com-common-sdk/core/BaseEcomSdk";
/** @internal */ var MAIN_OBJECT_NAME = "payairSamsungPay";
/** @internal */ var SDK_OBJECT_NAME = "samsungPaySdk";
var samsungPaySdk = new SamsungPaySdkImpl();
/*
  NOTE
  Added getVersion to window always. If user uses JS file, the object will be overwritten with proper getVersion,
  otherwise if using NPM this object will stay in the window object.
*/
/** @internal */ addGetVersionToWindow(MAIN_OBJECT_NAME, SDK_OBJECT_NAME, samsungPaySdk.getVersion);
var payairSamsungPay = {
    samsungPaySdk: samsungPaySdk,
    SamsungPayButtonColorEnums: SamsungPayButtonColorEnumsObj,
    SamsungPayButtonTypeEnums: SamsungPayButtonTypeEnumsObj,
    SamsungPayEventListenerEnums: SamsungPayEventListenerEnumsObj,
    SamsungPayEventTypeEnums: SamsungPayEventTypeEnumsObj,
};
export default payairSamsungPay;
